// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2OMhE","aside":"style_aside__3KTY2","error":"style_error__3k6gZ"};